module.exports = __webpack_public_path__ + "assets/img/healthy-aritce-icon.33b5748e.png";